import { gql, useQuery } from '@apollo/client';
import { DaapApplication } from '../interfaces/DaapApplication';

const DAAP_APPLICATIONS_QUERY = gql`
  query GetApplications {
    daapApplications {
      name
      displayName
      slug
      viewKey
      abbreviation
      order
    }
  }
`;

export const useApplications = () => {
  const { data, loading } = useQuery<{ daapApplications: DaapApplication[] }>(
    DAAP_APPLICATIONS_QUERY,
    {
      errorPolicy: 'all',
    }
  );

  const apps: DaapApplication[] = [...(data?.daapApplications ?? [])].sort(
    (a, b) => a.order - b.order || a.displayName.localeCompare(b.displayName)
  );

  return { apps, loading };
};
